/* RPS Wholesale theme — storefront behaviour
   Uses Shopify's AJAX Cart API (/cart/add.js, /cart.js, /cart/change.js). */
(function () {
  'use strict';
  var T = window.theme || { routes: {}, moneyFormat: '${{amount}}', strings: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = T.moneyFormat || '${{amount}}';
    var v = (cents / 100);
    function fixed(n, d, sep, dec) {
      var parts = n.toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return parts.length > 1 ? parts.join(dec) : parts[0];
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount', out;
    switch (key) {
      case 'amount_no_decimals': out = fixed(v, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = fixed(v, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = fixed(v, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = fixed(v, 2, "'", '.'); break;
      default: out = fixed(v, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]+>/g, '');
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg, isError) {
    var t = $('#Toast'); if (!t) return;
    $('[data-toast-msg]', t).textContent = msg;
    t.classList.toggle('error', !!isError);
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }

  /* ---------- header: phone menu drawer, search toggle, shrink on scroll ---------- */
  var header = $('[data-header]'), burger = $('[data-menu-toggle]');
  var isMobileNav = function () { return window.matchMedia('(max-width: 960px)').matches; };
  function setMenu(open) {
    if (!header) return;
    if (open) showHeader();
    header.classList.toggle('open', open);
    if (burger) { burger.setAttribute('aria-expanded', open); burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu'); }
    document.body.classList.toggle('no-scroll', open);
  }
  if (header && burger) {
    burger.addEventListener('click', function () { setMenu(!header.classList.contains('open')); });
    $$('[data-menu-close]').forEach(function (el) { el.addEventListener('click', function () { setMenu(false); }); });
    // On phones, first tap on a parent link expands its sub-menu instead of navigating
    $$('.nav a[data-parent]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (!isMobileNav()) return;
        var li = a.parentNode;
        if (!li.classList.contains('open')) {
          e.preventDefault();
          $$('.nav > ul > li.open').forEach(function (o) { if (o !== li) o.classList.remove('open'); });
          li.classList.add('open');
        }
      });
    });
  }

  /* Sticky header: hides while scrolling down, slides back when scrolling up.
     Only a transform changes, so the page below never moves or jumps. */
  var hdrSec = header && (header.closest('.shopify-section') || header.parentNode);
  var showHeader = function () {};
  if (header && hdrSec) {
    var docEl = document.documentElement, hdrHidden = false, hdrH = 0;
    var searchInput = $('#HeaderSearch');
    var hdrStart = 0, mark = document.createElement('div');
    mark.setAttribute('aria-hidden', 'true'); mark.style.cssText = 'height:0;margin:0;padding:0';
    hdrSec.parentNode.insertBefore(mark, hdrSec);
    var measure = function () {
      hdrH = hdrSec.offsetHeight;
      // where the header naturally sits (below the top bar). Not hdrSec.offsetTop — that moves once it's stuck.
      hdrStart = Math.max(0, mark.getBoundingClientRect().top + (window.scrollY || 0));
      docEl.style.setProperty('--hdr-h', hdrH + 'px');
      docEl.style.setProperty('--hdr-vis', (hdrHidden ? 0 : hdrH) + 'px');
    };
    var setHidden = function (h) {
      if (h === hdrHidden) return;
      hdrHidden = h;
      hdrSec.classList.toggle('is-hidden', h);
      docEl.classList.toggle('hdr-hidden', h);
      docEl.style.setProperty('--hdr-vis', (h ? 0 : hdrH) + 'px');
      if (h) { var a = document.activeElement; if (a && hdrSec.contains(a) && a !== searchInput) a.blur(); }
    };
    showHeader = function () { setHidden(false); };
    // never hide while something in the header is open or being typed in
    var busy = function () {
      return header.classList.contains('open') ||
        document.activeElement === searchInput ||
        !!hdrSec.querySelector('.rps-mm__panel.is-open, .rps-mm__panel:not([hidden])') ||
        hdrSec.matches(':hover') && !window.matchMedia('(hover: none)').matches;
    };
    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(hdrSec);
    else window.addEventListener('resize', measure);
    window.addEventListener('load', measure);

    var lastY = window.scrollY || 0, ticking = false;
    var onScroll = function () {
      ticking = false;
      var y = Math.max(0, window.scrollY || 0);
      var start = hdrStart;
      hdrSec.classList.toggle('is-stuck', y > start + 1);
      if (y <= start + hdrH) { setHidden(false); lastY = y; return; }
      var d = y - lastY;
      if (Math.abs(d) < 8) return;                          // ignore tiny jitter / iOS bounce
      if (d > 0 && !busy()) setHidden(true);
      else if (d < 0) setHidden(false);
      lastY = y;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
    }, { passive: true });
    hdrSec.addEventListener('focusin', showHeader);         // keyboard users tabbing into the header

    var st = $('[data-search-toggle]');
    if (st) st.addEventListener('click', function () {
      showHeader();
      if (searchInput) { searchInput.focus({ preventScroll: true }); searchInput.select && searchInput.select(); }
    });
  }

  /* ---------- brand strip ---------- */
  $$('[data-brand-scroll]').forEach(function (b) {
    b.addEventListener('click', function () {
      var track = $('#' + b.getAttribute('aria-controls'));
      if (track) track.scrollBy({ left: (+b.dataset.brandScroll) * track.clientWidth * 0.8, behavior: 'smooth' });
    });
  });

  /* ---------- quantity steppers + wishlist (delegated) ---------- */
  var WISH_KEY = 'rps_wishlist';
  function wishlist() { try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; } }
  function paintWishlist() {
    var list = wishlist();
    $$('[data-wish]').forEach(function (b) {
      var on = list.indexOf(b.dataset.wish) > -1;
      b.classList.toggle('on', on); b.setAttribute('aria-pressed', on);
    });
  }
  paintWishlist();

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qty]');
    if (q) {
      var input = $('input', q.parentNode);
      var max = +input.max || 999;
      input.value = Math.min(max, Math.max(1, (+input.value || 1) + (+q.dataset.qty)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var w = e.target.closest('[data-wish]');
    if (w) {
      var list = wishlist(), h = w.dataset.wish, i = list.indexOf(h);
      if (i > -1) list.splice(i, 1); else list.push(h);
      try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (err) { /* private mode */ }
      paintWishlist();
      toast(i > -1 ? 'Removed from wishlist' : 'Saved to wishlist');
    }
  });

  /* ---------- cart drawer ---------- */
  var drawer = $('#CartDrawer'), scrim = $('#CartScrim');
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }

  function renderCart(cart) {
    if (!drawer) return;
    setCount(cart.item_count);
    $('[data-cart-total]', drawer).textContent = money(cart.total_price);
    var box = $('[data-cart-items]', drawer); box.innerHTML = '';
    if (!cart.items.length) {
      box.innerHTML = '<p class="none">' + (T.strings.empty || 'Your cart is empty.') + '</p>';
      $('[data-cart-checkout]', drawer).setAttribute('hidden', '');
      return;
    }
    $('[data-cart-checkout]', drawer).removeAttribute('hidden');
    cart.items.forEach(function (it) {
      var el = document.createElement('div'); el.className = 'line';
      var img = it.image ? '<img class="img" src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2') + '" alt="" width="56" height="56" loading="lazy">' : '<span class="img"></span>';
      var opts = (it.variant_title && it.variant_title !== 'Default Title') ? ' · ' + it.variant_title : '';
      el.innerHTML = img +
        '<a class="n" href="' + it.url + '"></a>' +
        '<div class="t"></div>' +
        '<div class="m"></div>' +
        '<div class="c"><div class="qty"><button type="button" data-line="' + it.key + '" data-d="-1" aria-label="Decrease">−</button><input type="number" value="' + it.quantity + '" min="0" aria-label="Quantity" data-line-input="' + it.key + '"><button type="button" data-line="' + it.key + '" data-d="1" aria-label="Increase">+</button></div><button class="rm" type="button" data-remove="' + it.key + '">Remove</button></div>';
      $('.n', el).textContent = it.product_title;
      $('.t', el).textContent = money(it.final_line_price);
      $('.m', el).textContent = (it.sku ? 'Part #: ' + it.sku + ' · ' : '') + (it.vendor || '') + opts + ' · ' + money(it.final_price) + ' each';
      box.appendChild(el);
    });
  }

  function fetchCart() {
    return fetch(T.routes.cart + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  function changeLine(key, qty) {
    drawer.classList.add('loading');
    return fetch(T.routes.cartChange + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); })
      .catch(function () { toast(T.strings.cartError, true); })
      .then(function () { drawer.classList.remove('loading'); });
  }
  function openCart(open) {
    if (!drawer) return;
    drawer.classList.toggle('show', open); scrim.classList.toggle('show', open);
    drawer.setAttribute('aria-hidden', !open);
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) fetchCart().then(renderCart).catch(function () {});
  }

  if (drawer) {
    $$('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); openCart(true); });
    });
    $('[data-cart-close]', drawer).addEventListener('click', function () { openCart(false); });
    scrim.addEventListener('click', function () { openCart(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { openCart(false); setMenu(false); } });
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.dataset.remove) { changeLine(b.dataset.remove, 0); }
      else if (b.dataset.line) {
        var inp = $('[data-line-input="' + b.dataset.line + '"]', drawer);
        changeLine(b.dataset.line, Math.max(0, (+inp.value || 0) + (+b.dataset.d)));
      }
    });
    drawer.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-line-input]');
      if (inp) changeLine(inp.dataset.lineInput, Math.max(0, +inp.value || 0));
    });
  }

  /* ---------- AJAX add to cart ---------- */
  $$('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = (e.submitter && e.submitter.tagName === 'BUTTON') ? e.submitter : $('[type="submit"]', form), label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      var fd = new FormData(form);
      fetch(T.routes.cartAdd + '.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) { throw new Error(res.json.description || res.json.message || T.strings.cartError); }
          var qty = +fd.get('quantity') || 1;
          toast(qty + ' × ' + res.json.product_title + ' ' + (T.strings.added || 'added to cart'));
          if (btn) { btn.textContent = 'Added ✓'; }
          return fetchCart().then(function (cart) { renderCart(cart); openCart(true); });
        })
        .catch(function (err) { toast(err.message || T.strings.cartError, true); })
        .then(function () { if (btn) { setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 900); } });
    });
  });

  /* ---------- product page: variant select, thumbnails ---------- */
  var vs = $('[data-variant-select]');
  if (vs) {
    var cmpEl = $('[data-compare-target]'), skuEl = $('[data-sku-target]'), stockEl = $('[data-stock]');
    vs.addEventListener('change', function () {
      var o = vs.options[vs.selectedIndex];
      $$('[data-price-target]').forEach(function (el) { el.textContent = o.dataset.price; });
      if (skuEl) skuEl.textContent = o.dataset.sku ? 'Part #: ' + o.dataset.sku : '';
      if (cmpEl) { cmpEl.textContent = o.dataset.compare || ''; cmpEl.hidden = !o.dataset.compare; }
      var avail = o.dataset.available === 'true';
      if (stockEl) { stockEl.textContent = avail ? 'In Stock' : 'Out of Stock'; stockEl.classList.toggle('out', !avail); }
      $$('[data-add-button]').forEach(function (b) { b.disabled = !avail; b.textContent = avail ? 'Add to Cart' : 'Sold Out'; });
      if (o.dataset.image) { var main = $('[data-main-image]'); if (main) main.src = o.dataset.image; }
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', o.value); history.replaceState({}, '', u); }
    });
  }
  $$('[data-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      var main = $('[data-main-image]'); if (main) { main.src = b.dataset.thumb; main.srcset = ''; }
      $$('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === b); });
    });
  });

  /* ---------- product page: sticky buy bar on phones ---------- */
  var sticky = $('[data-sticky-buy]'), mainForm = $('#ProductForm');
  if (sticky && mainForm && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var out = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      sticky.classList.toggle('show', out); sticky.setAttribute('aria-hidden', !out);
    }, { threshold: 0 }).observe(mainForm);
  }

  /* ---------- collection sort ---------- */
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () { sort.form.submit(); });

  /* ---------- cart page: auto-submit on qty change ---------- */
  var cartForm = $('[data-cart-form]');
  if (cartForm) cartForm.addEventListener('change', function (e) {
    if (e.target.name && e.target.name.indexOf('updates[') === 0) cartForm.submit();
  });

  /* ---------- hero video: respect "reduce motion", and keep it playing on phones ---------- */
  // Older browsers without container units: tell the turned video how big the banner is
  var noCq = !(window.CSS && CSS.supports && CSS.supports('width', '1cqw'));
  $$('.hero--rot').forEach(function (h) {
    if (!noCq && h.classList.contains('hero--video-only')) return;   // pure CSS handles it
      var fit = function () { h.style.setProperty('--hero-w', h.clientWidth + 'px'); h.style.setProperty('--hero-h', h.clientHeight + 'px'); };
      fit(); if ('ResizeObserver' in window) new ResizeObserver(fit).observe(h); else window.addEventListener('resize', fit);
  });
  $$('.hero-video').forEach(function (v) {
    v.muted = true;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { v.removeAttribute('autoplay'); v.pause(); return; }
    var p = v.play && v.play(); if (p && p.catch) p.catch(function () {});
  });

  /* ---------- initial count ---------- */
  if (typeof T.cartCount === 'number') setCount(T.cartCount);
})();
